<template>
    <ob1-message-alerte
        v-if="displayViewCounterMessage"
        class="mt-1 mb-1"
        :title="viewCounterMessage"
        type="info"
        :is-simple-alerte="false"
        :is-mini="true"
    />
</template>

<script>
export default {
    name: "ViewCounter",
    props: {
        messageTemplate: {
            type: String,
            required: true
        },
        counterDelay: {
            type: Number,
            required: true
        },
        counterThreshold: {
            type: Number,
            required: true
        }
    },
    data: function () {
        return {
            viewCounter: 0
        }
    },
    computed: {
        viewCounterMessage() {
            let formattedCounter = new Intl.NumberFormat("fr-FR").format(this.viewCounter);
            return this.messageTemplate.replace("{0}", formattedCounter);
        },
        displayViewCounterMessage() {
            return this.viewCounter >= this.counterThreshold;
        }
    },
    created: function () {
        // Timer utilisé pour déclencher une mise à jour du compteur de vues toutes les n ms.
        // L'algo est le suivant :
        // - on crée un timer récurrent de n ms,
        // - quand le timer tombe, on regarde la valeur du compteur de vues dans utag_data et on la compare avec la valeur précédente,
        // - si ces deux valeurs sont différentes, le compteur de vues est mis à jour.
        const wait = this.counterDelay;
        this.timer = setInterval(() => {
            this.updateViewCounter();
        }, wait);
    },
    destroyed: function () {
        clearInterval(this.timer);
    },
    methods: {
        updateViewCounter: function () {
            if (!window.utag_data) {
                return;
            }
            let counter = window.utag_data.counter;
            if (counter !== undefined && counter[0] !== undefined && counter[0] !== this.viewCounter) {
                this.viewCounter = counter[0];
            }
        }
    }
}
</script>

<style scoped>

</style>
